import { GraphApiPermissionError } from './grapi-api-permission-errors.enum';

export interface GraphApiAppPermissionError {
  Code: string;
  Exception: GraphApiAppPermissionException;
}

export interface GraphApiAppPermissionException {
  ApplicationId: string;
  ClassName?: string;
  Data?: any;
  ExceptionMethod?: any;
  HResult?: number;
  InnerException?: any;
  Message?: string;
  RemoteStackIndex?: number;
  RemoteStackTraceString?: string;
  Source?: string;
  StackTraceString?: string;
  TenantId: string;
  WatsonBuckets?: any;
}

export class PermissionError {
  public code: GraphApiPermissionError;
  public applicationId: string;
  public tenantId: string;
  public message: string;
  public consentLink: string;
}

export class TenantSuspendedError extends PermissionError {}
